<template>
    <div class="notification-preview-container">
        <!-- App Notification (Android Style) -->
        <div v-if="type === 'app'" class="android-notification">
            <div class="notification-header">
                <div class="header-left">
                    <img src="@/assets/logo.png" alt="App Icon" class="app-icon" />
                    <span class="app-name">Amelsy</span>
                    <span class="separator">•</span>
                    <span class="time">Agora</span>
                </div>
                <v-icon small color="grey darken-1">mdi-chevron-down</v-icon>
            </div>
            <div class="notification-content">
                <div class="notification-title">{{ title }}</div>
                <div class="notification-body">{{ body }}</div>
            </div>
        </div>

        <!-- WhatsApp Notification (iOS Style) -->
        <div v-else-if="type === 'whatsapp'" class="whatsapp-notification">
            <div class="whatsapp-header">
                <div class="header-left">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" class="whatsapp-icon" />
                    <span class="app-name">Whatsapp</span>
                    <span class="separator">•</span>
                    <span class="time">Agora</span>
                </div>
            </div>
            <div class="whatsapp-content">
                <div class="whatsapp-sender-row">
                    <span class="whatsapp-title">{{ title }}</span>
                </div>
                <div class="whatsapp-body">{{ body }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationPreview',
    props: {
        title: {
            type: String,
            default: ''
        },
        body: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'app',
            validator: value => ['app', 'whatsapp'].includes(value)
        }
    }
}
</script>

<style scoped>
.notification-preview-container {
    display: flex;
    justify-content: center;
    padding: 10px;
    background-color: transparent; 
}

/* Android / App Style */
.android-notification {
    background-color: #ffffff;
    border-radius: 22px;
    padding: 16px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    font-family: 'Roboto', sans-serif;
}

.notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.header-left {
    display: flex;
    align-items: center;
}

.app-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    border-radius: 4px;
    object-fit: contain;
}

.app-name {
    font-size: 12px;
    color: #5f6368;
    font-weight: 500;
}

.separator {
    margin: 0 4px;
    font-size: 12px;
    color: #5f6368;
}

.time {
    font-size: 12px;
    color: #5f6368;
}

.notification-content {
    margin-top: 2px;
}

.notification-title {
    font-size: 15px;
    font-weight: 600;
    color: #202124;
    margin-bottom: 2px;
    line-height: 1.2;
}

.notification-body {
    font-size: 14px;
    color: #202124;
    line-height: 1.3;
    white-space: pre-wrap;
}

/* WhatsApp / iOS Style */
.whatsapp-notification {
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 13px;
    padding: 12px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    backdrop-filter: blur(20px);
}

.whatsapp-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
}

.whatsapp-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    border-radius: 4px;
    padding: 1px;
    background-color: #25D366;
}

.whatsapp-app-name {
    font-size: 11px;
    color: #8E8E93;
    font-weight: 500;
    letter-spacing: 0.2px;
}

.whatsapp-header .time {
    font-size: 11px;
    color: #8E8E93;
    font-weight: 400;
}

.whatsapp-content {
    padding-left: 0;
}

.whatsapp-sender-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
}

.whatsapp-title {
    font-size: 15px;
    font-weight: 600;
    color: #000000;
    line-height: 1.2;
}

.whatsapp-body {
    font-size: 15px;
    color: #1C1C1E;
    line-height: 1.3;
    white-space: pre-wrap;
}
</style>
